import { Trans, t } from '@lingui/macro';
import { FC, useEffect, useRef, useState } from 'react';

import { AppButton, Modal } from '@/UI';
import CustomInput from '@/UI/custom-input/CustomInput';
import CustomTextArea from '@/UI/custom-text-area/CustomTextArea';
import {
    deleteSection,
    editSection,
} from '@/Utils/socket-actions/ChannelActions/channelActions';
import trashIcon from '@/assets/icons/trash-red.svg';
import { BUTTON_TYPE } from '@/constants/enum';

import classes from './EditSection.module.css';

type IProps = {
    name?: string;
    id: string;
    onClose: () => void;
    description: string;
};

const EditSection: FC<IProps> = props => {
    const { name = '', id, onClose, description } = props;
    const editSecRef = useRef(null);
    const descriptionRef = useRef(null);

    const [canSubmit, setCanSubmit] = useState(false);
    const [textName, setTextName] = useState(name);

    const submitEditSectionHandler = event => {
        event.preventDefault();

        const payload = {
            section_id: id,
            name: editSecRef.current.value.trim(),
            description: descriptionRef.current.value.trim(),
        };
        editSection(payload);
        onClose();
    };
    const deleteSectionHandler = () => {
        deleteSection(id);
        onClose();
    };

    useEffect(() => {
        if (textName.trim() !== '') {
            setCanSubmit(true);
        } else {
            setCanSubmit(false);
        }
    }, [textName]);

    return (
        <Modal
            onClose={onClose}
            className={classes.modal}
            header={t`Edit Section`}>
            <form onSubmit={submitEditSectionHandler}>
                <p>
                    <Trans>Section name</Trans>
                </p>
                <CustomInput
                    autoFocus
                    ref={editSecRef}
                    className={classes['input-field']}
                    value={name}
                    onChange={event => setTextName(event.target.value)}
                    id={id}
                />
                <div>
                    <br />
                </div>
                <CustomTextArea
                    ref={descriptionRef}
                    label={t`description`}
                    name="server-description-input"
                    id="sectionDescriptionInput"
                    defaultValue={description}
                    className={classes['input-field']}
                    placeholder={t`Provide Informative content about this section`}
                    rows={3}
                    style={{ resize: 'none' }}
                />
                <div>
                    <br />
                </div>

                <div className={classes['d-flex']}>
                    <AppButton
                        onClick={deleteSectionHandler}
                        title={
                            <div className={classes['d-flex']}>
                                <img
                                    alt={t`delete`}
                                    src={trashIcon}
                                    className={classes['trash-icon']}
                                />
                                <Trans>Delete</Trans>
                            </div>
                        }
                        type="button"
                        buttonType={BUTTON_TYPE.transparent}
                        classStyles={`${classes['btn']} flex-1`}
                    />
                    <AppButton
                        type="submit"
                        title={t`Save`}
                        disable={!canSubmit}
                        classStyles={`${classes['btn']} flex-1`}
                    />
                </div>
            </form>
        </Modal>
    );
};
export default EditSection;
